import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
let dracoLoader = null;
export default function getDracoLoader() {
    if (!dracoLoader) {
        dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath('/draco/gltf/');
    }
    return dracoLoader;
}
